// =============================================================================
// Super Admin — Protected Route
// =============================================================================

import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore, verifyActivePlatformAdmin } from "@veorest/api-client";
import { ROUTES } from "../routes";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading, signOut } = useAuthStore();
  const location = useLocation();
  const [adminCheck, setAdminCheck] = useState<"pending" | "authorized" | "denied">("pending");

  useEffect(() => {
    if (isLoading) return;

    if (!user) {
      setAdminCheck("denied");
      return;
    }

    let cancelled = false;

    verifyActivePlatformAdmin(user.id).then(async ({ authorized }) => {
      if (cancelled) return;

      if (!authorized) {
        await signOut();
        setAdminCheck("denied");
        return;
      }

      setAdminCheck("authorized");
    });

    return () => {
      cancelled = true;
    };
  }, [user, isLoading, signOut]);

  if (isLoading || adminCheck === "pending") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--surface)]">
        <div className="w-8 h-8 border-2 border-[var(--accent)] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user || adminCheck === "denied") {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
